import { createSlice } from '@reduxjs/toolkit';
import { createWalletTransaction, findWalletTransaction, getWalletTransaction } from './api';
import { initialState } from './api/interface';

const walletTransactionSlice = createSlice({
  name: 'walletTransaction',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findWalletTransaction.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findWalletTransaction.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findWalletTransaction.rejected, (state, _) => {
      state.data = [];
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(createWalletTransaction.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createWalletTransaction.fulfilled, (state, action) => {
      state.data.push(action.payload);
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(createWalletTransaction.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
    builder.addCase(getWalletTransaction.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getWalletTransaction.fulfilled, (state, _) => {
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(getWalletTransaction.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } = walletTransactionSlice.actions;
export default walletTransactionSlice.reducer;
